"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var index_1 = __importDefault(require("../index"));
var randomInRange_1 = __importDefault(require("../../helpers/randomInRange"));
var getTickAnimation = function (confetti, decorateOptions) {
    confetti(decorateOptions({
        startVelocity: 30,
        spread: 360,
        ticks: 60,
        zIndex: 0,
        particleCount: 150,
        origin: {
            x: (0, randomInRange_1.default)(0.1, 0.3),
            y: Math.random() - 0.2,
        },
    }));
    confetti(decorateOptions({
        startVelocity: 30,
        spread: 360,
        ticks: 60,
        zIndex: 0,
        particleCount: 150,
        origin: {
            x: (0, randomInRange_1.default)(0.7, 0.9),
            y: Math.random() - 0.2,
        },
    }));
};
function Fireworks(props) {
    return react_1.default.createElement(index_1.default, __assign({ getTickAnimation: getTickAnimation }, props));
}
exports.default = Fireworks;
